import React, { createContext, useContext, useState } from "react";
import * as subscriptionService from "../services/subscription";

const SubscriptionContext = createContext(null);

export const SubscriptionProvider = ({ children }) => {
  const [plans, setPlans] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);

  const getPlans = async () => {
    try {
      const planData = await subscriptionService.getSubscriptionPlans();
      setPlans(planData);
      return planData;
    } catch (error) {
      throw error;
    }
  };

  const getCurrentSubscription = async () => {
    try {
      const subscription = await subscriptionService.getCurrentSubscription();
      setCurrentSubscription(subscription);
      return subscription;
    } catch (error) {
      throw error;
    }
  };

  const createCheckoutSession = async (planType) => {
    try {
      const session = await subscriptionService.createCheckoutSession(planType);
      return session;
    } catch (error) {
      throw error;
    }
  };

  const cancelSubscription = async () => {
    try {
      await subscriptionService.cancelSubscription();
      setCurrentSubscription(null);
    } catch (error) {
      throw error;
    }
  };

  const value = {
    plans,
    currentSubscription,
    getPlans,
    getCurrentSubscription,
    createCheckoutSession,
    cancelSubscription,
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useSubscription must be used within a SubscriptionProvider"
    );
  }
  return context;
};
